import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import React, { FC, memo, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';

const vt = viewTexts.dialogs.unapproveProject;

const MessageTop = styled.div`
  padding: 5px;
`;

const MessageBottom = styled.div`
  padding: 5px;
`;

interface Props {
  projectName: string;
  open: boolean;
  onClose: (yn: 'yes' | 'no') => void;
}

export const ConfirmUnapproveProjectDialog: FC<Props> = memo(
  ({ projectName, open, onClose }: Readonly<Props>) => {
    const onCloseDefault = useCallback(() => {
      onClose('no');
    }, [onClose]);

    const cancelClicked = useCallback(() => {
      onClose('no');
    }, [onClose]);

    const okClicked = useCallback(() => {
      onClose('yes');
    }, [onClose]);

    const message = useMemo<string[]>(() => vt.messageTop(projectName), [
      projectName
    ]);

    return (
      <Dialog onClose={onCloseDefault} open={open}>
        <DialogTitle>{vt.title}</DialogTitle>
        <DialogContent>
          <MessageTop>
            {message.map((msg, idx) => (
              <Typography key={idx}>{msg}</Typography>
            ))}
          </MessageTop>
          <MessageBottom>
            {vt.messageBottom.map((msg, idx) => (
              <Typography key={idx}>{msg}</Typography>
            ))}
          </MessageBottom>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelClicked} color='default'>
            {vt.buttons.cancel}
          </Button>
          <Button onClick={okClicked} color='primary'>
            {vt.buttons.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

ConfirmUnapproveProjectDialog.displayName = 'ConfirmUnapproveProjectDialog';
